<form class="w-100 h-100 form" [formGroup]="bannerForm" (ngSubmit)="sendData()" *ngIf="bannerInfo">
  <h4 class="text-center">Editar Slider</h4>
  <div class="row mx-0 my-3 pt-0 pb-3 w-100">

    <div class="pl-xl-0 mt-2 mb-4" [ngClass]="[6,14,11,12,13,15,16,17,18].includes(reference) ? 'col-6' : 'col-12'">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img" [src]="fileImg64" alt="img-banner" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image' : '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen de {{dimensions.width}}px x {{dimensions.height}}px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event)" />
        </div>
      </div>
    </div>

    <div class="col-6 pl-xl-0 mt-2 mb-4" *ngIf="[6,14,11,12,13,15,16,17,18].includes(reference)">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img" [src]="fileImg64Mobile" alt="img-banner" *ngIf="fileImg64Mobile">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo-mobile" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64Mobile ? 'image' : '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSizeMobile">
              Elegir imagen de {{dimensionsMobile.width}}px x {{dimensionsMobile.height}}px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSizeMobile">{{wrongSizeMobile}}</span>
          </label>
          <input id="file-upload-logo-mobile" type="file" accept="image/*" (change)="getBase64Mobile($event)" />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título</mat-label>
          <input matInput placeholder="Título" formControlName="title" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-12" *ngIf="[2,4,6,10,14,11,12,13,15].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título 2</mat-label>
          <input matInput placeholder="Título" formControlName="title2" required>
        </mat-form-field>
      </div>
    </div>
    <div class="col-12" *ngIf="[16,17,18].includes(reference)">
      <div class="mb-3">
        <label class="example-full-width w-100">Título 2</label>
        <quill-editor placeholder="Ingresar texto..." formControlName="title2" [maxLength]="maxLength">
          <div quill-editor-toolbar class="w-100">
            <span class="ql-formats">
              <button class="ql-bold" [title]="'Bold'"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-align" [title]="'Justificación de texto'">
                <option selected></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="bullet"></button>
            </span>
          </div>
        </quill-editor>
        <mat-error *ngIf="bannerForm.value.title2.length > maxLength">Máximo de caracteres es de {{maxLength}}!
        </mat-error>
        <mat-hint align="end"> {{bannerForm.value.title2.length}} / {{maxLength}} caracteres!</mat-hint>
      </div>
    </div>
    <div class="col-6" *ngIf="![7,10,16,17,18].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Subtítulo</mat-label>
          <input matInput placeholder="Subtítulo" formControlName="subTitle" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[1,9].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Subtítulo 2</mat-label>
          <input matInput placeholder="subtitulo 2" formControlName="subTitle2">
        </mat-form-field>
      </div>
    </div>

    <div class="col-6">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Orden</mat-label>
          <input type="number" matInput placeholder="1, 2, 3 ..." formControlName="order" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
      <div class="vs-outline-editCard btn-custom-banner custom-banner mb-5" *ngIf="reference === 7">
        <img class="given-img mw-100 mh-100" [src]="urlImgLogo | safeDom" formControlName="title2" alt="img-banner">
      </div>
    </div>
    <div class="col-6" *ngIf="[2,4,6,14,11,12,13,15,16,17,18].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link de redirección</mat-label>
          <input matInput placeholder="Link de redirección" formControlName="urlButton4" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
          <mat-hint>Solo visible en "Fondos e Inversion"</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3" *ngIf="[1,5,9,7].includes(reference)">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{reference !== 5 ? 'Texto de botón' : 'Texto de botón Agendar'}}</mat-label>
          <input matInput placeholder="Texto de botón" formControlName="nameButton1" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
      <div class="mb-3" *ngIf="[7].includes(reference)">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Logo Vida Plus</mat-label>
          <input matInput placeholder="Logo Vida Plus" formControlName="title2" required (keyup)="title2KeyUp($event)">
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
      <div class="mb-3" *ngIf="[2,6,4,14,11,12,13,15,16,17,18].includes(reference)">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Texto de botón</mat-label>
          <input matInput placeholder="Texto de botón" formControlName="nameButton4" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
          <mat-hint>Solo visible en "Fondos e Inversion"</mat-hint>
        </mat-form-field>
      </div>
      <div class="mb-3" *ngIf="[2,4,6,14,11,12,13,15,16,17,18].includes(reference)">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Texto de botón Agendar</mat-label>
          <input matInput placeholder="Texto de botón Agendar" formControlName="nameButton1" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>

    <mat-divider class="mb-5" *ngIf="[2,14,11,12,13,15].includes(reference)"></mat-divider>
    <div class="col-6" *ngIf="[2,14,11,12,13,15].includes(reference)">
      <div class="mb-3 d-flex flex-column">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fact sheets título</mat-label>
          <input matInput placeholder="Texto fact sheets" formControlName="nameButton3" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[2,14,11,12,13,15].includes(reference)">
      <div class="mb-3 d-flex flex-column">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fact sheets referencia imagen</mat-label>
          <input matInput placeholder="Texto fact sheets" formControlName="img3" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <!--    <div class="col-6" *ngIf="reference === 5">-->
    <!--      <div class="mb-3 d-flex flex-column">-->
    <!--        <mat-label>Cita con asesor</mat-label>-->
    <!--        <mat-radio-group formControlName="validate" aria-label="cita con asesor"-->
    <!--                         (change)="(bannerForm.get('validate').value === 1 ? bannerForm.get('urlButton1').disable() : bannerForm.get('urlButton1').enable())">-->
    <!--          <mat-radio-button [value]="1">Si</mat-radio-button>-->
    <!--          <mat-radio-button [value]="0">No</mat-radio-button>-->
    <!--        </mat-radio-group>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="col-6" *ngIf="[1,9].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link de redirección</mat-label>
          <input matInput placeholder="Link de redirección" formControlName="urlButton1" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col-6" *ngIf="[2,14].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Botón Fact sheet 1</mat-label>
          <input matInput placeholder="Botón fact sheet 1" formControlName="nameButton5" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[2,14,11,12,13,15].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link Fact sheet 1</mat-label>
          <input matInput placeholder="Link fact sheet 1" formControlName="urlButton5" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[2,14].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Botón Fact sheet 2</mat-label>
          <input matInput placeholder="Botón fact sheet 2" formControlName="nameButton6" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[2,14].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link Fact sheet 2</mat-label>
          <input matInput placeholder="Link fact sheet 2" formControlName="urlButton6" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[2,14].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Botón Fact sheet 3</mat-label>
          <input matInput placeholder="Botón fact sheet 1" formControlName="nameButton7" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="[2,14].includes(reference)">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link Fact sheet 3</mat-label>
          <input matInput placeholder="Link fact sheet 1" formControlName="urlButton7" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="bannerForm.invalid || ([16,17,18].includes(reference) && bannerForm.value.title2.length > maxLength)">      
      Guardar
    </button>
  </div>
</form>